import { render, staticRenderFns } from "./SalesReceiptsCompare.vue?vue&type=template&id=d47177aa&scoped=true&"
import script from "./SalesReceiptsCompare.vue?vue&type=script&lang=js&"
export * from "./SalesReceiptsCompare.vue?vue&type=script&lang=js&"
import style0 from "./SalesReceiptsCompare.vue?vue&type=style&index=0&id=d47177aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47177aa",
  null
  
)

export default component.exports